import { fetchEndpoint } from '../server/network'

// 首页推荐商品列表
export const homeProductList = () => fetchEndpoint('/v2/ecapi.home.product.list')

//shouyebannaer
export const homeBanner = () => fetchEndpoint('/v2/ecapi.banner.list')


// WEBPACK FOOTER //
// ./src/api/home.js